<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" sm="6" xs="12" class="text-center">
              <p class="text-head">Weight LTX Test</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <h4>Plant</h4>
              <v-text-field
                v-model="data.PlantCode"
                label=""
                outlined
                single-line
                dense
                readonly
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <h4>Batch No</h4>
              <v-text-field
                v-model="data.BatchNo"
                label=""
                outlined
                single-line
                dense
                readonly
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <h4>Date Batch</h4>
              <v-text-field
                v-model="data.DateBatch"
                label=""
                outlined
                single-line
                dense
                readonly
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <h4 text>Sender Name</h4>

              <v-text-field
                v-model="data.SenderName"
                label=""
                outlined
                single-line
                dense
                readonly
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12" xs="12">
              <h4>Car License</h4>
              <v-text-field
                v-model="data.Carlicense"
                label=""
                outlined
                single-line
                dense
                readonly
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12" xs="12">
              <h4>Goods Weight (KG)</h4>
              <v-text-field
                v-model="data.GoodsWeight"
                label=""
                outlined
                single-line
                dense
                readonly
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <h4>
                Remark <span class="red--text"><strong>* </strong></span>
              </h4>
              <v-textarea
                v-model.trim="data.Remark"
                label=""
                rows="1"
                auto-grow
                outlined
                dense
                clearable
                counter="220"
                :rules="[rules.required, rules.length(220)]"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="data.TRLTXWeightDetails"
                fixed-header
                :mobile-breakpoint="0"
                :single-select="true"
                item-key="LTXWeightDeailID"
                class="elevation-1 scollTable"
                style="width: 100%"
              >
                <template v-slot:body="{ items, isSelected, select }">
                  <tbody v-if="items.length > 0">
                    <tr v-for="(item, index) in items" :key="index">
                      <td style="min-width: 98px" class="text-center">
                        <v-simple-checkbox
                          color="blue"
                          :value="isSelected(item)"
                          @click="select(item, !isSelected(item))"
                        ></v-simple-checkbox>
                      </td>
                      <td style="min-width: 105px" class="text-center">
                        <v-simple-checkbox
                          color="blue"
                          :value="item.SelectedLabApproval === 1 ? true : false"
                          readonly
                          disabled
                        ></v-simple-checkbox>
                      </td>
                      <td style="min-width: 200px">{{ item.LTXScaleBill }}</td>
                      <td style="min-width: 200px">{{ item.SampleNo }}</td>
                      <td style="min-width: 130px">{{ item.GrossWeight }}</td>
                      <td style="min-width: 120px">{{ item.NetWeight }}</td>
                      <td style="min-width: 80px">{{ item.DRC }}</td>
                      <td style="min-width: 105px" class="text-center">
                        <v-simple-checkbox
                          color="blue"
                          :value="item.SelectedLab === 1 ? true : false"
                          readonly
                          disabled
                        ></v-simple-checkbox>
                      </td>
                      <td style="min-width: 200px">{{ item.CommentLab }}</td>
                      <td style="min-width: 200px">{{ item.Tester }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td :colspan="headers.length" style="text-align: center">
                        No information
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn
          v-if="data.TRLTXWeightDetails.length > 0"
          dark
          color="green"
          @click="onSubmit"
        >
          Approve
        </v-btn>
      </v-card-actions>
    </v-card>
    <DialogMessageComponent
      :show="showError.show"
      :title="showError.title"
      :message="showError.message"
      :close="showError.close"
      @confirm="closeMessageDialog"
    />
    <LoadingDialog :show="loading" />
  </v-container>
</template>

<script>
import axios from "axios";
import DialogMessageComponent from "@/components/message-dialog.vue";
import LoadingDialog from "@/components/loading-dialog.vue";
export default {
  name: "HomeView",
  components: {
    DialogMessageComponent,
    LoadingDialog,
  },
  data() {
    return {
      loading: false,
      valid: true,
      showError: {
        show: false,
        title: "",
        message: "",
        close: false,
      },
      data: {
        LTXWeightID: null,
        PlantCode: null,
        BatchNo: null,
        DateBatch: null,
        SenderName: null,
        Carlicense: null,
        GoodsWeight: null,
        Remark: null,
        UserNameSelect: null,
        TRLTXWeightDetails: [],
      },
      selected: [],
      headers: [
        { text: "FM Approve", value: "", sortable: false },
        { text: "Lab Approve", value: "SelectedLabApproval", sortable: false },
        { text: "LTXScale Bill", value: "LTXScaleBill" },
        { text: "Sample No", value: "SampleNo" },
        { text: "Gross Weight", value: "GrossWeight" },
        { text: "Net Weight", value: "NetWeight" },
        { text: "DRC", value: "DRC" },
        { text: "Selected Lab", value: "SelectedLab", sortable: false },
        { text: "CommentLab", value: "CommentLab" },
        { text: "Tester", value: "Tester" },
      ],
      rules: {
        length: (len) => (v) =>
          (v || "").length <= len ||
          `Invalid character length, required ${len}`,
        required: (v) => !!v || "This field is required",
      },
    };
  },
  async mounted() {
    if (this.$route.query.id) {
      this.getData(this.$route.query.id);
    } else {
      this.openMessageDialog("Error", "Can't find id", false);
    }
  },
  methods: {
    async onSubmit() {
      if (this.$refs.form.validate()) {
        if (this.selected.length > 0) {
          try {
            const data = {
              LTXWeightDeailID: this.selected[0].LTXWeightDeailID,
              RemarkApprove: this.data.Remark,
            };
            const result = await axios.put(
              "/trltxweight/" + this.$route.query.id,
              data,
              {
                baseURL: this.$config.VUE_APP_API,
              }
            );
            if (result) {
              if (result.status === 200) {
                if (result.data.result === "success") {
                  this.$router.replace({
                    path: "/success",
                    query: { msg: "Success" },
                  });
                } else {
                  this.openMessageDialog("Error", result.data.message, true);
                }
              } else {
                this.openMessageDialog(
                  "Error " + result.statusText,
                  result,
                  true
                );
              }
            } else {
              this.openMessageDialog("Error", "No response from api", true);
            }
          } catch (error) {
            this.openMessageDialog("Error", error, true);
          }
        } else {
          this.openMessageDialog("Error", "Please select data", true);
        }
      }
    },
    async getData(id) {
      try {
        const result = await axios.get("/trltxweight/" + id, {
          baseURL: this.$config.VUE_APP_API,
        });
        if (result) {
          if (result.status === 200) {
            if (result.data.result === "success") {
              if (result.data.data.rows.length > 0) {
                const data = result.data.data.rows[0];
                this.data = data;
                if (this.data.TRLTXWeightDetails.length > 0) {
                  for (const item of this.data.TRLTXWeightDetails) {
                    item.FMApproval = false;
                  }
                }
                this.$refs.form.resetValidation();
              } else {
                this.openMessageDialog("Error", "No information", true);
              }
            } else {
              this.openMessageDialog("Error", result.data.message, true);
            }
          } else {
            this.openMessageDialog(
              "Error " + result.statusText,
              result.message,
              true
            );
          }
        } else {
          this.openMessageDialog("Error", "No response from api", true);
        }
      } catch (error) {
        this.openMessageDialog("Error", error, true);
      }
    },
    openMessageDialog(title, message, close) {
      this.loading = false;
      this.showError.title = title;
      this.showError.message = message;
      this.showError.close = close;
      this.showError.show = true;
    },

    closeMessageDialog() {
      this.loading = false;
      this.showError.show = false;
      this.showError.title = "";
      this.showError.message = "";
      this.showError.close = false;
    },
  },
};
</script>
<style scoped>
.text-head {
  color: #8246af;
  font-size: 38px;
  font-weight: bold;
}
</style>
